import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AttendeeHomeFiltersComponent } from '~/attendee/components/pages/home/filters/filters.component';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-attendee-home-filters-mobile',
  templateUrl: './filters-mobile.component.html',
})
export class AttendeeHomeFiltersMobileComponent
  extends AttendeeHomeFiltersComponent
  implements OnDestroy, OnInit
{
  private readonly subscriptions = new Subscription();

  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public isMobileDevice: boolean;

  constructor(private readonly matchMediaService: MatchMediaService) {
    super();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }
}
